// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Red border for input fields */
.input-red {
    border-left: 4px solid #dc3545 !important;
}

/* Green border for input fields */
.input-green {
    border-left: 4px solid #28a745 !important;
}

.result-label{
    background-color: #deb887 !important;
}
/* Style unit text - keep default Bootstrap styling */
.input-group-text {
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-left: none;
    color: #495057;
    font-size: 0.875rem;
    border-radius: 0 0.25rem 0.25rem 0;
}

/* Remove left border from unit text for merged appearance */
.input-group input {
    border-right: none;
    border-radius: 0.25rem 0 0 0.25rem;
}

/* Card styling - remove shadow and add border */
.card {
    border: 1px solid rgba(0, 0, 0, 0.125);
    box-shadow: none !important;
    border-radius: 0.5rem;
}

/* Reduce input group width */
.input-group {
    max-width: 200px;
}

.card-header {
    font-family: 'GothamNarrowBold', sans-serif;
    font-weight: 600;
    background-color: #0B2D71;
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/rheological-hierarchy/standoff-calculator/standoff-calculator.component.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;IACI,yCAAyC;AAC7C;;AAEA,kCAAkC;AAClC;IACI,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;AACxC;AACA,qDAAqD;AACrD;IACI,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA,4DAA4D;AAC5D;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA,gDAAgD;AAChD;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;AACf","sourcesContent":["/* Red border for input fields */\n.input-red {\n    border-left: 4px solid #dc3545 !important;\n}\n\n/* Green border for input fields */\n.input-green {\n    border-left: 4px solid #28a745 !important;\n}\n\n.result-label{\n    background-color: #deb887 !important;\n}\n/* Style unit text - keep default Bootstrap styling */\n.input-group-text {\n    background-color: #e9ecef;\n    border: 1px solid #ced4da;\n    border-left: none;\n    color: #495057;\n    font-size: 0.875rem;\n    border-radius: 0 0.25rem 0.25rem 0;\n}\n\n/* Remove left border from unit text for merged appearance */\n.input-group input {\n    border-right: none;\n    border-radius: 0.25rem 0 0 0.25rem;\n}\n\n/* Card styling - remove shadow and add border */\n.card {\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    box-shadow: none !important;\n    border-radius: 0.5rem;\n}\n\n/* Reduce input group width */\n.input-group {\n    max-width: 200px;\n}\n\n.card-header {\n    font-family: 'GothamNarrowBold', sans-serif;\n    font-weight: 600;\n    background-color: #0B2D71;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
